import type { RouteLocationRaw } from '#vue-router'
import type { NavigateToOptions } from '#app/composables/router'

const isString = (value: any): value is string => {
  return typeof value === 'string' || value instanceof String
}

export default () => {
  const localePath = useLocalePath()
  const currentShop = useCurrentShop()
  const currentRoute = useRoute()

  const toLocalePath = (route: RouteLocationRaw): RouteLocationRaw => {
    if (!isString(route)) {
      return localePath(route)
    }

    const normalizedPath = normalizePathRoute(route)
    return hasLocalePrefix(normalizedPath, currentShop.value?.path)
      ? normalizedPath
      : localePath(normalizedPath)
  }

  const localizedNavigateTo = (
    route: RouteLocationRaw,
    options?: NavigateToOptions,
  ) => {
    if (!isString(route)) {
      return navigateTo(localePath(route), options)
    }

    const normalizedPath = normalizePathRoute(route)
    const dedupedLocalePath = hasLocalePrefix(
      normalizedPath,
      currentShop.value?.path,
    )
      ? normalizedPath
      : localePath(normalizedPath)

    return navigateTo(dedupedLocalePath, options)
  }

  // Builds a pagination link target. Page 1 points to the bare path (no
  // ?page=1), which is a noindex duplicate of the canonical URL (ECOM-1495);
  // pages 2+ carry ?page=N. Other query params (tag, filter, sort) are kept.
  const paginationLinkTo = (page: number): RouteLocationRaw => {
    const query = { ...currentRoute.query }
    if (page <= 1) {
      delete query.page
    } else {
      query.page = String(page)
    }
    return toLocalePath({ params: { ...currentRoute.params }, query })
  }

  return {
    localizedNavigateTo,
    toLocalePath,
    paginationLinkTo,
  }
}
